var map = {
	"./EBK.svg": "c9cf",
	"./EBKComment.svg": "9756",
	"./arranged-en.svg": "9703",
	"./arranged.svg": "fbe6",
	"./arrears-en.svg": "c697",
	"./arrears.svg": "46d0",
	"./basePrice.svg": "c157",
	"./borrowed.svg": "0ef7",
	"./breakfast.svg": "8b9b",
	"./children.svg": "264c",
	"./coupon.svg": "e24d",
	"./dashboard.svg": "f782",
	"./datakanban.svg": "a4e0",
	"./deposit.svg": "c44e",
	"./dp-comment.svg": "5394",
	"./example.svg": "30c3",
	"./extend-en.svg": "ceff",
	"./extend.svg": "9a57",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./fin.svg": "4ef4",
	"./finace.svg": "24a7",
	"./fintao.svg": "939f",
	"./form.svg": "eb1b",
	"./future.svg": "b7df",
	"./fz-comment.svg": "2721",
	"./guest.svg": "de4b",
	"./hardware.svg": "1e89",
	"./hic.svg": "3473",
	"./hotelInfo.svg": "a362",
	"./khtc-comment.svg": "b6c4",
	"./link.svg": "18f0",
	"./managefin.svg": "6118",
	"./market.svg": "3338",
	"./money.svg": "3046",
	"./mt-comment.svg": "a454",
	"./nested.svg": "dcf8",
	"./noWifi.svg": "57cd",
	"./notice.svg": "fc99",
	"./order.svg": "11ff",
	"./orderReport.svg": "95f9",
	"./password.svg": "2a3d",
	"./preLeave.svg": "a7be",
	"./priceCalendar.svg": "28ca",
	"./production.svg": "cdb4",
	"./pullnew.svg": "493e",
	"./qn-comment.svg": "83df",
	"./quality.svg": "f22a",
	"./qzComment.svg": "acb7",
	"./realTime.svg": "e512",
	"./reply-comment.svg": "d285",
	"./roomOrder.svg": "ae5b",
	"./salesActivity.svg": "62f0",
	"./sellingPrice.svg": "9458",
	"./setting.svg": "05ff",
	"./simple.svg": "260d",
	"./stayIn-en.svg": "6935",
	"./stayIn.svg": "af8c",
	"./stock.svg": "2466",
	"./stopService.svg": "3f0c",
	"./table.svg": "47f1",
	"./tc-comment.svg": "898e",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./video.svg": "8f2b",
	"./vip.svg": "1296",
	"./xc-comment.svg": "6a8e",
	"./youhuiquan.svg": "8ac6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";